import { render } from "./ActionPlanDashboard.vue?vue&type=template&id=46deb087"
import script from "./ActionPlanDashboard.vue?vue&type=script&lang=js"
export * from "./ActionPlanDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__